import {observer, React} from '@api'
import {Button, Chip} from '@material-ui/core'
import * as css from './ChangeLogClosableChip.css'
import {ArrowDropUp, ArrowDropDown} from '@material-ui/icons'

interface IChangeLogClosableChipProps {
  title: string,
  icon: any
  active: boolean
  onClick?: () => void
  applied?: boolean
}

export const ChangeLogClosableChip = observer<IChangeLogClosableChipProps>(function ChangeLogClosableChip({title, icon, active, applied, onClick}) {
  return (
    <Button onClick={onClick}
            startIcon={icon}
            data-filter-applied={applied}
            classes={{endIcon: css.endIcon}}
            endIcon={active ? <ArrowDropUp/> : <ArrowDropDown/>}
            data-type={'chip'}
            disableRipple
            disableTouchRipple
            disableFocusRipple
            className={css.root}>
      <div className={css.title} dangerouslySetInnerHTML={{__html: title}}></div>
    </Button>
    /*<Chip
      data-type={'chip'}
      className={css.root}
      label={title}
      avatar={icon}
      onClick={onClick}
      clickable
      onDelete={onClick}
      deleteIcon={}
    />*/
  )
})

ChangeLogClosableChip.defaultProps = {
  onClick: () => {}
}


// WEBPACK FOOTER //
// ./src/modules/changelog/ChangeLogClosableChip.tsx